var _path, _path2, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.044 19l-4.956 5 4.956 5M28.956 19l4.956 5-4.956 5",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(99.914 5.646 18.395) skewX(-.173)",
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M0-.75h15.807"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.908,
    y: 6.75,
    width: 34.183,
    height: 34.5,
    rx: 7.25,
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5LjA0MzggMTlMMTQuMDg3OSAyNEwxOS4wNDM4IDI5IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTI4Ljk1NjIgMTlMMzMuOTEyMSAyNEwyOC45NTYyIDI5IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPGxpbmUgeTE9Ii0wLjc1IiB4Mj0iMTUuODA3MiIgeTI9Ii0wLjc1IiB0cmFuc2Zvcm09Im1hdHJpeCgtMC4xNzIxNjQgMC45ODUwNjggLTAuOTg0NTQzIC0wLjE3NTE0NSAyNC43MzgzIDE2KSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxyZWN0IHg9IjYuOTA4MiIgeT0iNi43NSIgd2lkdGg9IjM0LjE4MjgiIGhlaWdodD0iMzQuNSIgcng9IjcuMjUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4K";
export { SvgCode as ReactComponent };